<template>
  <div
    :class="['tooltip', tooltipPosition]"
    data-testid="new-feature-tooltip"
  >
    <div class="tooltip-container">
      <div class="tooltip__title">
        {{ title }}
      </div>
      <div class="tooltip__description">
        {{ description }}
      </div>
      <div class="tooltip-footer">
        <button
          data-testid="tooltip-close"
          class="btn btn__text"
          @click="close"
        >
          Got it
        </button>
      </div>
    </div>
    <div :class="['tooltip-arrow', arrowPosition]" />
  </div>
</template>

<script>
export default {
  name: 'NewFeatureTooltip',
  props: ['title', 'description', 'position'],
  computed: {
    tooltipPosition() {
      return `tooltip--${this.position}`
    },
    arrowPosition() {
      const arrowPosition = {
        left: 'tooltip-arrow--right',
        right: 'tooltip-arrow--left',
        top: 'tooltip-arrow--bottom',
        bottom: 'tooltip-arrow--top',
      }
      return arrowPosition[this.position]
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip {
  position: absolute;
  min-width: 325px;
  min-height: 150px;
  background-color: $white;
  border-radius: 5px;
  border-top: 8px solid $green;
  box-shadow: 0px 10px 20px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  &--right {
    left: 4em;
    top: 0;
    bottom: 0;
    margin: auto 0;
  }
  &--left {
    right: 4em;
    top: 0;
    bottom: 0;
    margin: auto 0;
  }
  &--bottom {
    top: 4em;
    left: -135px;
  }
  &--top {
    bottom: 4em;
    left: -135px;
  }
  &-container {
    padding: 1em;
    color: $black;
  }
  &-footer {
    @include flex-display();
    @include flex-justify-content(flex-end);
  }
  &__title {
    font-weight: 600;
    margin-bottom: 0.5em;
  }
  &__description {
    color: $grey-text;
  }
  &-arrow {
    position: absolute;
    width: 0;
    height: 0;
    box-sizing: border-box;
    &--left {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid $white;
      left: -10px;
      top: 40%;
    }
    &--right {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid $white;
      right: -10px;
      top: 40%;
    }
    &--top {
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      border-bottom: 10px solid $green;
      top: -15px;
      left: calc(50% - 10px);
    }
    &--bottom {
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      border-top: 10px solid $white;
      bottom: -10px;
      left: calc(50% - 10px);
    }
  }
}
</style>
